import {createContext, useContext} from "react";
import CommonStore from "../stores/CommonStore";

export const CommonContext = createContext({} as CommonStore);
export const CommonContextProvider = CommonContext.Provider;
export const useCommonContext = () => {
    return useContext(CommonContext)
}